module.exports = __webpack_public_path__ + "static/media/transfer-ownership.de27de7e.svg";